<script setup>
import { computed, ref } from 'vue';
import { useIntervalFn } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { MESSAGE_STATUS } from './constants';

import Icon from 'next/icon/Icon.vue';

const { status } = defineProps({
  status: {
    type: String,
    required: true,
    validator: value => Object.values(MESSAGE_STATUS).includes(value),
  },
});

const { t } = useI18n();

const progresIconSequence = [
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
];

const progessIcon = ref(progresIconSequence[0]);

const rotateIcon = () => {
  const currentIndex = progresIconSequence.indexOf(progessIcon.value);
  const nextIndex = (currentIndex + 1) % progresIconSequence.length;
  progessIcon.value = progresIconSequence[nextIndex];
};

useIntervalFn(rotateIcon, 500, {
  immediate: status === MESSAGE_STATUS.PROGRESS,
  immediateCallback: false,
});

const statusIcon = computed(() => {
  const statusIconMap = {
    [MESSAGE_STATUS.SENT]: 'i-ph-check',
    [MESSAGE_STATUS.DELIVERED]: 'i-ph-checks',
    [MESSAGE_STATUS.READ]: 'i-ph-checks',
  };

  return statusIconMap[status];
});

const statusColor = computed(() => {
  const statusIconMap = {
    [MESSAGE_STATUS.SENT]: 'text-white/60',
    [MESSAGE_STATUS.DELIVERED]: 'text-white/80',
    [MESSAGE_STATUS.READ]: 'text-[#4ade80]',
  };

  return statusIconMap[status];
});

const tooltipText = computed(() => {
  const statusTextMap = {
    [MESSAGE_STATUS.SENT]: t('CHAT_LIST.SENT'),
    [MESSAGE_STATUS.DELIVERED]: t('CHAT_LIST.DELIVERED'),
    [MESSAGE_STATUS.READ]: t('CHAT_LIST.MESSAGE_READ'),
    [MESSAGE_STATUS.PROGRESS]: t('CHAT_LIST.SENDING'),
  };

  return statusTextMap[status];
});
</script>

<template>
  <Icon
    v-if="status === MESSAGE_STATUS.PROGRESS"
    v-tooltip.top-start="tooltipText"
    :icon="progessIcon"
    class="text-n-slate-10"
  />
  <!-- ✓ → ✓✓ → ✓✓ azul trocam com uma transição curta (24/10/2026): o ícone novo cresce
       no lugar do anterior, em vez de piscar. A chave é o estado. -->
  <Transition v-else name="msg-visto" mode="out-in">
    <Icon
      :key="status"
      v-tooltip.top-start="tooltipText"
      :icon="statusIcon"
      :class="statusColor"
      class="size-[14px] msg-visto"
    />
  </Transition>
</template>

<style scoped>
.msg-visto {
  transition: color var(--mov-2) var(--mov-curva);
}

.msg-visto-enter-active {
  transition:
    opacity var(--mov-2) var(--mov-curva),
    transform var(--mov-2) var(--mov-curva);
}

.msg-visto-leave-active {
  transition: opacity var(--mov-1) var(--mov-curva-saida);
}

.msg-visto-enter-from {
  opacity: 0;
  transform: scale(0.6);
}

.msg-visto-leave-to {
  opacity: 0;
}
</style>
